import React from 'react'
import {connect} from "react-redux";
import PropTypes from 'prop-types'

import { 
  selectLastActiveModal,
} from '../../State/selectors.js'

import {
  openModal, 
} from '../../State/actions.js'

const mapStateToProps = (state) => {
  var lastModalId = selectLastActiveModal(state)
  return { lastModalId }
}

const actions = {
  openModal,
}

class ModalLinkControl extends React.Component {
  static get propTypes () {
    return {
      context: PropTypes.string, 
      copy: PropTypes.string,
      lastModalId: PropTypes.string,
      openModal: PropTypes.func
    }
  }

  render () {
    var { copy, context, lastModalId, openModal } = this.props
    var targetModal = context === "any" ? lastModalId : context
    var linkClasses = [
      "filter-link",
      "fdn-search-control uk-button uk-button-default uk-flex uk-flex-row-reverse",
      `id-${context}`
    ]
    return (
      <div className="bar-link open">
        <div>
          <a uk-icon='filter' className={ linkClasses.join(" ") }
            onClick={ () => openModal(targetModal) }>

            { copy }
          </a>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, actions)(ModalLinkControl);
